import { MouseEventHandler } from 'react';
import EditIcon from '@mui/icons-material/Edit';
import { Grid, IconButton, Tooltip } from '@mui/material';

import { QuotationListActionsProps } from './props';
import { QUOTATION_EDIT } from '../../../../../../routes/paths';

export const QuotationListActions = ({ id }: QuotationListActionsProps) => {
    const handleEdit: MouseEventHandler<HTMLButtonElement> | undefined = (
        e
    ) => {
        e.stopPropagation();
        window.open(`${QUOTATION_EDIT}/${id}`, '_blank');
    };

    return (
        <Grid textAlign="left" width="100%">
            <Tooltip title="Editar">
                <IconButton size="small" onClick={handleEdit}>
                    <EditIcon type="submit" sx={{ color: 'primary.main' }} />
                </IconButton>
            </Tooltip>
        </Grid>
    );
};
